<template>
  <ul class="nav-category-list list-none mt-7 grid gap-4 lg:gap-x-8">
    <slot />
  </ul>
</template>

<style lang="scss" scoped>
.nav-category-list {
  grid-template-columns: repeat(auto-fill, minmax(8.5rem, 1fr));

  @apply lg:grid-cols-4;
}
</style>
